import annotations from './annotations';
import state from './state';

export default {
	fileName: 'demo.html',
	annotations,
	state
};
